// src/utils/animations.js

export const fadeInUp = {
    hidden: { opacity: 0, y: 60 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };
  
  export const staggerContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3
      }
    }
  };
  
  export const slideInLeft = {
    hidden: { opacity: 0, x: -60 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };
  
  export const slideInRight = {
    hidden: { opacity: 0, x: 60 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };
  
  export const fadeIn = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6
      }
    }
  };
  
  export const scaleIn = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.6
      }
    }
  };
  
  export const globalStyles = `
    .floating-particle {
      position: absolute;
      width: 10px;
      height: 10px;
      background: rgba(251, 191, 36, 0.1);
      border-radius: 50%;
    }
  
    .floating-particle:nth-child(1) {
      top: 20%;
      left: 20%;
      animation: float 20s infinite linear;
    }
  
    .floating-particle:nth-child(2) {
      top: 60%;
      right: 30%;
      animation: float 15s infinite linear;
    }
  
    .floating-particle:nth-child(3) {
      bottom: 20%;
      left: 40%;
      animation: float 18s infinite linear;
    }
  
    @keyframes float {
      0% { transform: translate(0, 0) rotate(0deg); }
      25% { transform: translate(100px, 100px) rotate(90deg); }
      50% { transform: translate(0, 200px) rotate(180deg); }
      75% { transform: translate(-100px, 100px) rotate(270deg); }
      100% { transform: translate(0, 0) rotate(360deg); }
    }
  
    .gradient-overlay {
      background: linear-gradient(45deg, rgba(251, 191, 36, 0.1), rgba(251, 191, 36, 0.05));
    }
  `;